import { linkResolver } from './linkResolver'

export const generateAuthorBreadcrumbsData = ({ type, article, author }) => {
  const articleData = JSON.parse(article)
  const typeData = JSON.parse(type)

  return [
    {
      disabled_link: false,
      link_text: {
        text:
          typeData.uid && typeData.uid[0].toUpperCase() + typeData.uid.slice(1),
      },
      link: {
        url: linkResolver(typeData),
      },
    },
    {
      disabled_link: false,
      link_text: {
        text: articleData.data.title.text,
      },
      link: {
        url: linkResolver(articleData),
      },
    },
    {
      disabled_link: true,
      link_text: {
        text: author.name,
      },
      link: {
        url: '',
      },
    },
  ]
}
